import { getQuery, execQuery, luaScript, rawPostToServer } from '../../helpers/helper_store';

const state = {
	tasksTable: [],
	paramsTable: [],
	typeTaskTable: []
};
const mutations = {
	setTasksTable: (state, data) => (state.tasksTable = data),
	setParamsTable: (state, data) => (state.paramsTable = data),
	setTypeTaskTable: (state, data) => (state.typeTaskTable = data)
};

const actions = {
	getTasksTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getTasksTable', null, rootState.login)
				.then((result) => {
					commit('setTasksTable', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	getParamsTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getCmdParamsTable', null, rootState.login).then((result) => {
				commit('setParamsTable', result);
				resolve();
			});
		});
	},
	getTypeTaskTable({ rootState, commit }) {
		return new Promise((resolve, reject) => {
			getQuery('getTypeTaskTable', null, rootState.login)
				.then((result) => {
					commit('setTypeTaskTable', result);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createTask({ rootState }, data) {
		return new Promise((resolve, reject) => {
			execQuery(
				'insTaskTable',
				[
					data.captionSelected,
					data.pathSelected,
					data.isPacketableChecked,
					data.idTypeTaskSelected,
					data.commentSelected
				],
				rootState.login
			)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delTaskTable({ rootState }, idTask) {
		return new Promise((resolve, reject) => {
			luaScript('taskeditor', 'del_gTasks', { idTask }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	updTaskParams({ rootState }, { idTask, paramsArray }) {
		return new Promise((resolve, reject) => {
			luaScript('taskeditor', 'ins_gCmdLine', { idTask, data: paramsArray }, rootState.login)
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	taskExport({ rootState }, { idArray, action }) {
		return new Promise((resolve, reject) => {
			const object = {
				cmd: 'luaFunc',
				params: {
					script: "taskExport",
					funcname: "run",
					funcparam: {
						taskid: idArray,
						action
					}
				}
			};
			rawPostToServer(
				object,
				rootState.login
			)
				.then((result) => {
					resolve(result.request.response);
				})
				.catch(() => {
					reject();
				})
		})
	}
};
const getters = {
	getTasksTable: (state) => (Array.isArray(state.tasksTable) ? state.tasksTable : [state.tasksTable]),
	getParamsTable: (state) => (Array.isArray(state.paramsTable) ? state.paramsTable : [state.paramsTable]),
	getTypeTaskTable: (state) => (Array.isArray(state.typeTaskTable) ? state.typeTaskTable : [state.typeTaskTable])
};
export default {
	state,
	mutations,
	actions,
	getters
};
